import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Typography,
} from "@material-tailwind/react";
import { useEffect } from "react";
import Select from "react-select";
import { Input } from "@material-tailwind/react";
import { getPriceVrientVendor, getVendorPrice } from "@/store/slices/rfqSlice";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import ShowLoader from "@/components/Loader";
import ScrollToTop from "@/components/ScrollToTop";
import FilePreview from "@/components/FilePreview";
import { fetchCountry } from "@/store/slices/internalUsersSlice";
import { fetchCity } from "@/store/slices/productSlice";
import { useTranslation } from "react-i18next";

export function ViewVendorVarientPriceModal({ onClose, item }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('order');
  const { loading, vendors, rfq_product_vendors_prices } = useSelector(
    (state) => state.rfq
  );
  const { countries } = useSelector((s) => s.internalUser);
  const { cities } = useSelector((s) => s.product);

  const initialValue = {
    rfq_product_id: item?.rfq_product_id,
    product_id: item?.product_id,
    vendors: [
      {
        vendor_id: null,
        quantity: null,
        price: null,
        vendor_file: null,
        pickup_location: "",
        pickup_landmark:"",
        latitude: null,
        longitude: null,
      },
    ],
  };

  const { control, setValue, watch, reset } = useForm({
    defaultValues: initialValue,
  });

  const vendorRows = watch("vendors");

  useEffect(() => {
    dispatch(
      getPriceVrientVendor({
        color_id: item?.color?.id,
        product_id: item?.product_id,
        size_id: item?.size?.id,
        index:0
      })
    );
    dispatch(
      getVendorPrice({
        rfq_product_id: item?.rfq_product_id,
      })
    );
    dispatch(fetchCountry());
  }, []);

  useEffect(() => {
    if (rfq_product_vendors_prices?.length > 0) {
      const formatted = rfq_product_vendors_prices.map((row) => ({
        vendor_id: row.vendor_id,
        quantity: row.quantity,
        price: row.price,
        vendor_file: row.vendor_file,
        vendor_type: row.vendor_type,
        country_id: row.country_id,
        city_id: row.city_id,
        pickup_location:
          row.pickup_location ?? "",
        pickup_landmark:row?.pickup_landmark ?? null,
        latitude: row.latitude ?? row.lat ?? null,
        longitude: row.longitude ?? row.lng ?? null,
      }));
      setValue("vendors", formatted);
      rfq_product_vendors_prices?.map((row, index)=>{
          dispatch(fetchCity({country_id:row.country_id, index:index}));
          dispatch(
              getPriceVrientVendor({
                  color_id: item?.color?.id,
                  product_id: item?.product_id,
                  size_id: item?.size?.id,
                  country_id: row.country_id,
                  city_id: row.city_id,
                  index:index
              })
          );
      });
    } else {
      reset(initialValue);
    }
  }, [rfq_product_vendors_prices]);

  const close = () => {
    reset(initialValue);
    onClose();
  };

  return (
    <Dialog open={true} handler={close} size="lg" className="rounded-2xl p-0">
      {loading && <ShowLoader />}
      <ScrollToTop />

      <DialogHeader className="flex justify-between items-center px-6 py-4 border-b">
        <div>
          <Typography className="text-2xl font-bold text-gray-900">
           {t('view_added_vendor_title')}
          </Typography>
          <Typography className="text-sm text-gray-600 mt-1">
            {t('view_vendor_read_only_message')}
          </Typography>
        </div>
      </DialogHeader>

      <DialogBody className="px-6 max-h-[65vh] overflow-y-auto">
        {/* Product block */}
        <div className="flex items-center space-x-4 mb-6">
          <img
            src={item?.product_image || "/img/photo-gallery.png"}
            className="w-40 h-40 object-cover rounded-md border"
            alt="product"
          />
          <div>
            <p className="font-semibold text-gray-900 text-lg leading-tight">
              {t('product_name_label')}: {item?.product_name}
            </p>
            <p className="text-sm font-medium text-gray-600">
              {t('total_quantity_label')}:{" "}
              <span className="text-gray-900">{item?.quantity}</span>
            </p>

            <div className="flex flex-wrap gap-2 mt-2">
              <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded flex items-center gap-2 border">
                {t('color_label')}: {item?.color?.name}
                {item?.color?.hex && (
                  <span
                    className="w-3 h-3 rounded-full border border-gray-300"
                    style={{ backgroundColor: item?.color?.hex }}
                  />
                )}
              </span>

              <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded border">
                {t('size_label')}: {item?.size?.name}
              </span>
            </div>

            <div className="flex gap-4 mt-2 border-t pt-2 border-dashed border-gray-300">
              <div>
                <p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">
                  {t('purchase_price_label')}
                </p>
                <p className="text-sm font-semibold text-blue-700">
                  {item?.product_base_price}
                </p>
              </div>
              <div>
                <p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">
                  {t('sale_price_label')}
                </p>
                <p className="text-sm font-semibold text-green-700">
                  {item?.product_sale_price}
                </p>
              </div>
              <div className="ml-auto text-right">
                <p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">
                  {t('total_budget_label')}
                </p>
                <p className="text-sm font-bold text-gray-900">
                  {(
                    Number(item?.product_sale_price || 0) *
                    Number(item?.quantity || 0)
                  ).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-6 mt-4">
          {vendorRows.map((row, index) => {
            const fileToPreview = row?.vendor_file || null;

            return (
              <div
                key={index}
                className="border p-5 rounded-xl bg-white shadow-sm relative"
              >
                <div className="flex justify-between items-center mb-3">
                  <h3 className="font-semibold text-gray-800">
                    {t('vendor_number_label', { number: index + 1 })}
                  </h3>
                </div>

                {/* Country */}
                <div className="mb-4">
                    <Typography variant="small" className="font-medium">
                    {t('country_label')} 
                    </Typography>
                    <Select
                    placeholder={t('select_country_placeholder')}
                    onChange={(country) =>{
                        setValue(
                        `vendors.${index}.country_id`,
                        country?.value || null,
                        { shouldValidate: true }
                        );
                        dispatch(fetchCity({country_id:country?.value, index:index}));
                        dispatch(
                            getPriceVrientVendor({
                                color_id: item?.color?.id,
                                product_id: item?.product_id,
                                size_id: item?.size?.id,
                                country_id:country?.value,
                                city_id:watch(`vendors.${index}.city_id`),
                                index:index
                            })
                        );
                        }}
                    options={countries}
                    value={
                        countries?.find(
                        (opt) =>
                            opt.value ===
                            watch(`vendors.${index}.country_id`)
                        ) || null
                    }
                    isDisabled={true}
                    />
                </div>
                    {/* City */}
                <div className="mb-4">
                    <Typography variant="small" className="font-medium">
                    {t('city_label')} 
                    </Typography>
                    <Select
                    placeholder={t('select_city_placeholder')}
                    onChange={(city) =>{
                        setValue(
                        `vendors.${index}.city_id`,
                        city?.value || null,
                        { shouldValidate: true }
                        );
                        dispatch(
                            getPriceVrientVendor({
                                color_id: item?.color?.id,
                                product_id: item?.product_id,
                                size_id: item?.size?.id,
                                country_id:watch(`vendors.${index}.country_id`),
                                city_id:city?.value,
                                index:index 
                            })
                        );
                    }}
                    options={cities?.length > 0 ? cities[index] : []}
                    value={
                        cities?.length > 0 ? cities[index]?.find(
                        (opt) =>
                            opt.value ===
                            watch(`vendors.${index}.city_id`)
                        ) || null : null
                    }
                    isDisabled={true}
                    />
                </div>

                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t('select_vendor_label')}
                </label>

                <Controller
                  name={`vendors.${index}.vendor_id`}
                  control={control}
                  render={({ field }) => (
                    <Select
                      placeholder={t('select_vendor_placeholder')}
                      options={vendors?.length > 0 ? vendors[index] : []}
                      value={
                        vendors?.length > 0
                          ? vendors[index]?.find((v) => v.value === field.value) || null
                          : null
                      }
                      getOptionLabel={(option) => option.label?.split(" (")[0]} 
                      isDisabled
                      className="mb-1"
                      noOptionsMessage={() => t('no_vendor_available')}
                    />
                  )}
                />
                {/* Pickup location */}
                <div className="mt-4">
                  <Typography variant="small" className="font-medium">
                     {t('pickup_landmark_label')}
                  </Typography>
                  <p className="text-sm text-gray-900 mt-1">
                    {row?.pickup_landmark || t('not_applicable')}
                  </p>
                  {row?.latitude != null && row?.longitude != null && (
                    <p className="text-xs text-gray-500 mt-1">
                      Lat {Number(row.latitude).toFixed(6)}, Lng{" "}
                      {Number(row.longitude).toFixed(6)}
                    </p>
                  )}
                </div>

                {/* Pickup location */}
                <div className="mt-4">
                  <Typography variant="small" className="font-medium">
                    {t('pickup_location_label')}
                  </Typography>
                  <p className="text-sm text-gray-900 mt-1">
                    {row?.pickup_location || t('not_applicable')}
                  </p>
                </div>

                <label className="block text-sm font-medium text-gray-700 mt-3">
                  {t('price_label')}
                </label>
                <Controller
                  name={`vendors.${index}.price`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      min="0"
                      type="number"
                      value={field.value || ""}
                      readOnly
                      className="!border-t-blue-gray-200 bg-gray-100 cursor-not-allowed"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                      placeholder={t('vendor_price_placeholder')}
                    />
                  )}
                />

                <label className="block text-sm font-medium text-gray-700 mt-3">
                  {t('quantity_label')}
                </label>
                <Controller
                  name={`vendors.${index}.quantity`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="number"
                      min="1"
                      max={item?.quantity}
                      {...field}
                      readOnly
                      className="!border-t-blue-gray-200 bg-gray-100 cursor-not-allowed"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                      placeholder={t('quantity_placeholder')}
                    />
                  )}
                />

                {fileToPreview && (
                  <div className="mt-4">
                    <label className="block text-sm font-medium mb-2">
                      {t('vendor_file_label')}
                    </label>
                    <FilePreview file={fileToPreview} isView />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </DialogBody>

      <DialogFooter className="flex justify-end gap-4 border-t pt-4">
        <button
          type="button"
          onClick={close}
          className="px-5 py-2 rounded-lg text-gray-700 hover:bg-gray-100"
        >
          {t('close_button')}
        </button>
      </DialogFooter>
    </Dialog>
  );
}

export default ViewVendorVarientPriceModal;
